import React, { useContext, useEffect, useState } from 'react'
import Layout from '../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import layoutBgImg from '../Images/layout/others.jpg'
import { Context } from '../Store/context'
import { GetStateDuty } from '../api/Queries/get'
import Loading from '../Component/loader/loader'
import ServicesLayout from '../Component/layout/services-layout'
import GlobalLayout from '../Component/layout/global-layout'

const StateDuty = () => {
    const [document, setDocument] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { t, i18n } = useTranslation();
    const { showError } = useContext(Context);

    const getLawContent = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_content;
        } else if (currentLang === 'en') {
            return laws.eng_content;
        }
        return laws.tm_content;
    };

    useEffect(() => {
        setIsLoading(true)
        const getStateDuty = async () => {
            try {
                const data = await GetStateDuty()
                setIsLoading(false)
                setDocument(data[0] || null);
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getStateDuty()
    }, [showError])

    return (
        <GlobalLayout
            title={`${t('state_duty')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Dowlet pajy, Döwlet pajy, Государственная пошлина"
        >
            <div className='mb-20'>
                <Layout
                    title={t('state_duty')}
                    layoutBgImg={layoutBgImg}
                />

                <ServicesLayout />

                <main className='media'>
                    <div className='bg-white p-8 w-full
                                dark:bg-dark-box dark:text-dark-text'>
                        {isLoading ? <Loading /> :
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: document ?
                                        getLawContent(document) : ''
                                }}
                            />
                        }
                    </div>
                </main>
            </div>
        </GlobalLayout>
    )
}

export default StateDuty